import React, { useMemo } from 'react';
import Layout from '../../components/Layout';
import { PawPrint, DollarSign, ArrowRight, Dog } from 'lucide-react';

// NOTE: In a real-world application, this rate would be fetched in real-time 
// from a crypto API (like CoinGecko or CoinMarketCap) in a useEffect hook.
const MOCK_DOGE_TO_USD_RATE = 0.147; // 1 DOGE is worth 0.147 USD

// --- FIX: Updated the icon URL to a current, stable asset link ---
const DOGE_ICON_URL = 'https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1547792252';

const mockServices = [
  { id: 1, name: 'Basic Wash & Dry', usdPrice: 45.00, description: 'A refreshing bath with premium shampoo and a full towel & blow dry.' },
  { id: 2, name: 'Full Groom Package', usdPrice: 75.00, description: 'Includes wash, cut, ear cleaning, and nail trim. The full transformation!' },
  { id: 3, name: 'Pawdicure Express', usdPrice: 25.00, description: 'A quick nail trim, filing, and paw pad moisturizing treatment.' },
  { id: 4, name: 'De-Shedding Deluxe', usdPrice: 120.00, description: 'Intensive treatment to minimize shedding, perfect for double-coated breeds.' },
];

const GroomingServicesDoge = () => {

  const convertUsdToDoge = (usd) => {
    if (MOCK_DOGE_TO_USD_RATE === 0) return 'N/A';
    // Round down to two decimal places for cryptocurrency display
    return (usd / MOCK_DOGE_TO_USD_RATE).toFixed(2);
  };

  const ServiceCard = ({ service }) => {
    const dogePrice = useMemo(() => convertUsdToDoge(service.usdPrice), [service.usdPrice]);

    return (
      <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-teal-500 transition duration-300 transform hover:scale-[1.02] shadow-xl">
        <PawPrint className="w-8 h-8 text-indigo-400 mb-3" />
        <h3 className="text-2xl font-bold text-white mb-2">{service.name}</h3>
        <p className="text-gray-400 text-sm mb-4">{service.description}</p>
        
        <div className="space-y-2 pt-4 border-t border-gray-700">
          
          {/* USD Price Display */}
          <div className="flex items-center justify-between text-lg text-gray-300">
            <DollarSign className="w-5 h-5 text-gray-500" />
            <span>Price (USD):</span>
            <span className="font-mono font-bold text-teal-400">${service.usdPrice.toFixed(2)}</span>
          </div>

          {/* DOGE Price Display */}
          <div className="flex items-center justify-between text-xl font-extrabold">
            {/* --- FIX APPLIED HERE: Use the stable URL constant --- */}
            <img src={DOGE_ICON_URL} alt="Doge Coin Icon" className="w-6 h-6 mr-2" />
            <span className="text-white">Price (DOGE):</span>
            <span className="font-mono text-xl text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500">
                {dogePrice} DOGE
            </span>
          </div>

        </div>

        {/* Schedule Button (Call to Action) */}
        <button
          className="w-full mt-6 py-3 bg-teal-600 text-white font-bold rounded-lg hover:bg-teal-700 transition duration-300 flex items-center justify-center space-x-2"
          onClick={() => alert(`Initiating booking for ${service.name} at ${dogePrice} DOGE...`)} // Using a mock action
        >
          <span>Book with DOGE</span>
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    );
  };

  return (
    <Layout>
      <div className="py-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header and Rate Display */}
        <div className="text-center mb-12 p-6 bg-gray-900 rounded-xl border border-teal-500/50">
          <Dog className="w-12 h-12 mx-auto text-yellow-400 mb-3" />
          <h1 className="text-5xl font-extrabold text-white mb-3">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500">
              DOGE-Powered
            </span>{' '} 
            Grooming Services
          </h1>
          <p className="text-lg text-gray-400 mt-4">
            All prices are quoted in USD and payable in Dogecoin (DOGE).
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Current Rate (Mock): 1 DOGE ≈ ${MOCK_DOGE_TO_USD_RATE} USD
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockServices.map(service => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>

      </div>
    </Layout>
  );
};

export default GroomingServicesDoge;
